import React from "react";
import Sidedraw from "./Sidedraw";
import Sidedrawitem from "./Sidedrawitem";
import Tooltip from "@material-ui/core/Tooltip";
import Cookies from "universal-cookie";
import { decode } from "base-64";
import {
  HomeIcon,
  CogIcon,
  QuestionMarkCircleIcon,
  PencilAltIcon,
  AnnotationIcon,
  CalendarIcon,
  AcademicCapIcon,
  BadgeCheckIcon,
  BookOpenIcon,
  BriefcaseIcon,
  PresentationChartLineIcon,
  PuzzleIcon,
} from "@heroicons/react/outline";
import GlossaryIcon from "../icons/GlossaryIcon";
import NoteIcon from "../icons/NoteIcon";
import Movies from "../icons/Movies";

const cookies = new Cookies();
function Sidebarcomponent() {
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = "members";
  }
  return (
    <React.Fragment>
      <Sidedraw>
        <Sidedrawitem
          title="Home"
          hidden={user === "members" ? false : true}
          href="/user"
        >
          <Tooltip title="Home" placement="right">
            <HomeIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Home"
          hidden={user === "institue" ? false : true}
          href="/i/institute"
        >
          <Tooltip title="Home" placement="right">
            <HomeIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>

        <Tooltip title="Education" placement="right">
          <Sidedrawitem
            title="Education"
            hidden={user === "members" ? false : true}
            href="/education"
          >
            <AcademicCapIcon className="w-6 text-gray-800" />
          </Sidedrawitem>
        </Tooltip>

        <Tooltip title="Glossary" placement="right">
          <a
            href="https://docs.google.com/spreadsheets/d/1OCpmMrj1wG-UbrauME9mxFFb19vkiX3FDm5n07tvQps/edit?usp=sharing"
            className="sideBarIcons-list"
            target="_blank"
            rel="noopener noreferrer"
          >
            <GlossaryIcon className="w-6 text-gray-800" />
          </a>
        </Tooltip>

        <Tooltip title="Notes" placement="right">
          <a
            href="https://docs.google.com/document/d/14W7STekyyr4N29lVilRAiXHd67OiK7SMpgnibC4YEM4/edit?usp=sharing"
            className="sideBarIcons-list"
            target="_blank"
            rel="noopener noreferrer"
          >
            <NoteIcon className="w-6 text-gray-800" />
          </a>
        </Tooltip>

        <Tooltip title="Movies" placement="right">
          <a
            href="https://docs.google.com/spreadsheets/d/1ws3ysgq9JvCtYL8EM1LOBWN65cHYUujdQcLiHEtyQyo/edit?usp=sharing"
            className="sideBarIcons-list"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Movies className="w-6 text-gray-800" />
          </a>
        </Tooltip>
        <Sidedrawitem
          title="Manage notices"
          hidden={user === "institue" ? false : true}
          href="/i/institute/managenotices"
        >
          <Tooltip title="Manage notices" placement="right">
            {/* <EventNoteIcon style={{ fill: "var(--mintBlack)", fontSize: "30px" }} className="text-3xl" /> */}
            <AnnotationIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Manage events"
          hidden={user === "institue" ? false : true}
          href="/i/institute/events"
        >
          <Tooltip title="Manage events" placement="right">
            {/* <EmojiEventsOutlinedIcon style={{ fill: "var(--mintBlack)", fontSize: "30px" }} className="text-3xl" /> */}
            <CalendarIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem title="Create Blog" href="/createblogs">
          <Tooltip title="Create Blog" placement="right">
            <PencilAltIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem
          title="Create Question"
          hidden={user === "members" ? false : true}
          href="/createquestions"
        >
          <Tooltip title="Create Question" placement="right">
            <QuestionMarkCircleIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
        <Sidedrawitem title="Account settings" href="/account">
          <Tooltip title="Account settings" placement="right">
            <CogIcon className="w-6 text-gray-800" />
          </Tooltip>
        </Sidedrawitem>
      </Sidedraw>
    </React.Fragment>
  );
}

export default Sidebarcomponent;
